import { ASIAN_GAMES_LIST_UPDATE_RECEIVED, RESET_ASIAN_GAMES_LIST, ASIAN_GAMES_TOGGLE_DATE_SORT } from "../actions/actionTypes/index";

const AsianGamesReducer = (state = {
    byDayeSort: false
}, action) => {
    switch (action.type) {
        case ASIAN_GAMES_LIST_UPDATE_RECEIVED:
            return {
                ...state,
                [action.key]: {
                    ...state.games,
                    ...action.payload
                }
            };
        case RESET_ASIAN_GAMES_LIST:
            return action.key
                ? {
                    [action.key]: undefined
                }
                : {

                };
        case ASIAN_GAMES_TOGGLE_DATE_SORT:
            return {
                ...state,
                byDayeSort: !state.byDayeSort
            };
        default :
            return state;
    }
};

export default AsianGamesReducer;
